import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "@arc/i18n";
import { useTonWallet, useTonWallets } from "@arc/sdk";
import { Drawer } from "@arc/ui/drawer";
import { List } from "@arc/ui/list";

import { AppRoute } from "@/constants/routes";

import { WalletItem } from "./WalletItem";

interface WalletsListProps {
  isOpen: boolean;
  hideButton?: boolean;
  onClose: () => void;
}

export const WalletsListModal = ({ isOpen, hideButton = false, onClose }: WalletsListProps) => {
  const { t } = useTranslation("wallet");
  const navigate = useNavigate();

  const { list } = useTonWallets();
  const activeWallet = useTonWallet();

  useEffect(() => {
    if (isOpen) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list.length, activeWallet?.id]);

  const onExpand = hideButton ? undefined : () => navigate(AppRoute.import);

  return (
    <Drawer height={list.length > 3 ? "full" : "md"} isOpen={isOpen} title={t("WALLET_LIST.TITLE")} onClose={onClose}>
      <List className="m-4" expandText={t("WALLET_LIST.ADD_NEW")} withGap onExpand={onExpand}>
        {list.map((wallet) => (
          <WalletItem
            key={wallet.id}
            address={wallet.address}
            id={wallet.id}
            title={wallet.walletName}
            version={wallet.walletVersion}
          />
        ))}
      </List>
    </Drawer>
  );
};
